import { Fragment, useState } from "react";
import SimpleBalanceSheetTable from "../components/SimpleBalanceSheetTable";
import Select from "react-select";
import DetailedBalanceSheetTable from "../components/DetailedBalanceSheetTable";

const BalanceSheet = () => {
  const [viewMode, setViewMode] = useState(null);

  const handleViewModeChange = (selectedOption) => {
    if (selectedOption) {
      setViewMode(selectedOption.value);
    } else {
      setViewMode(null);
    }
  };

  return (
    <Fragment>
      <h1>Balance Sheet</h1>
      <div className="m-3">
        <label htmlFor="viewMode">View Mode:</label>
        <Select
          value={
            viewMode
              ? {
                  value: viewMode,
                  label:
                    viewMode === "simple" ? "Simple View" : "Detailed View",
                }
              : null
          }
          options={[
            { value: "simple", label: "Simple View" },
            { value: "detailed", label: "Detailed View" },
          ]}
          onChange={handleViewModeChange}
          placeholder="Select view mode"
          isClearable
        />
      </div>

      {viewMode && (
        <div className="table-responsive m-3">
          {viewMode === "simple" ? (
            <SimpleBalanceSheetTable />
          ) : (
            <DetailedBalanceSheetTable />
          )}
        </div>
      )}
    </Fragment>
  );
};

export default BalanceSheet;
